import {useMemo} from 'react'
import {useLocation} from 'react-router-dom'

export function openPage(pageUrl) {
    window.location.assign(pageUrl)
}

export function openNewPage(pageUrl) {
    window.open(pageUrl)
}

export function useQueryParams() {
    const {search} = useLocation()

    return useMemo(() => new URLSearchParams(search), [search])
}
